import { NotificationsPage } from "@/features/notifications/notifications-page";

export default function NotificationsRoutePage() {
  return <NotificationsPage />;
}
